"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function () { return m[k]; } });
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule)
        return mod;
    var result = {};
    if (mod != null)
        for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
                __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-for-in-array */
/* eslint-disable vue/no-reserved-keys */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
const vue_1 = require("vue");
//
// List/pagination mixin
//
const lodash = __importStar(require("lodash"));
const qs = __importStar(require("qs"));
const vue_2 = require("vue");
// Dependencies:
// - lodash
// - uiMixin (flash, progressbar)
const uiMixin_1 = __importDefault(require("./uiMixin"));
exports.default = vue_1.defineComponent({
    mixins: [uiMixin_1.default],
    data() {
        return {
            // listing data
            items: [],
            // pagination
            page: 1,
            count: 25,
            totalPages: 1,
            total: 0,
            order: 'id',
            direction: 'asc',
            listMode: 'paginate',
            isAutoloadInitialized: false,
            loadedPages: [],
            lastPageItemsIndex: null,
            // search & filters
            search: '',
            filtersDefault: [],
            filters: [],
            isAnyFilterActive: false,
            _oldFilters: null,
            rnd: 0,
            loading: false,
            showNotFoundNotification: true,
            done: null,
            // update url with list parameters
            listUpdateUrl: true,
            // update global page title with list results label
            listUpdateTitle: true,
            listArgsLoaded: false,
            listIsEditable: false,
            listIsSelectionEnabled: false,
            listSelected: [],
            listSelectedActionButtons: [],
            $lodash: lodash,
        };
    },
    watch: {
        // on search expression changed
        /*search () {
          this.listClear()
        },*/
        // on any filter value changed
        filters: {
            handler() {
                if (this.listArgsLoaded) { // only if index and filters already read from url/params (otherwise any filter value change will run this watcher)
                    // this.listClear()
                    this.isAnyFilterActive = !this.$lodash.isEqual(this.filters, this.filtersDefault);
                    if (this.listMode !== 'autoload') {
                        this.listClear();
                        this.reload();
                    }
                    else {
                        if (this._oldFilters) {
                            this.listClear();
                        }
                    }
                    this._oldFilters = this.filters;
                }
            },
            deep: true
        },
        loading(status) {
            this.progressbar(status);
        },
        /**
         * (Number of) Selected items changed
         */
        listSelected(newValue) {
            if (newValue.length) { // one or more items selected
                this.listSelectedNotify();
            }
            else {
                this.listSelectedNotifyClose();
            }
            /*if (newValue.length === oldValue.length) { // if single list item selected new & old values are this same; if all/none - are different
              this.onListItemSelectionChanged()
            }*/
        }
    },
    computed: {
        // base index pagination parameters (required to force apollo reload)
        index() {
            return {
                page: this.page,
                count: this.count,
                order: this.order,
                direction: this.direction,
                search: this.search
            };
        },
        listSelectedItemsCount() {
            return this.listSelected.length;
        }
    },
    created() {
        this.onListCreated();
    },
    mounted() {
        this.onListMounted();
    },
    beforeUnmount() {
        this.listUnselectAll();
    },
    methods: {
        onListCreated() {
            // set filters defaults (equal to initial values)
            this.filtersDefault = this.$lodash.clone(this.filters);
            // apply index parameters from url
            this.applyUrlParams();
        },
        onListMounted() {
            vue_2.nextTick(() => {
                this.listArgsLoaded = true; // allows to start query listing data
            });
        },
        onListItemToggle(listSelected) {
            this.listSelected = listSelected;
            // TODO: make it work with `watch`
            if (listSelected.length) { // one or more items selected
                this.listSelectedNotify();
            }
            else {
                this.listSelectedNotifyClose();
            }
        },
        //
        // List component callbacks
        //  `
        updateCurrentPage(page) {
            this.page = page;
        },
        updateCount(count) {
            this.count = count;
            this.listClear();
        },
        updateOrderByField(field) {
            if (this.order === field) { // reverse order
                this.direction = this.direction === 'asc' ? 'desc' : 'asc';
            }
            this.order = field;
            this.listClear();
        },
        updateOrderDirection(direction) {
            this.direction = direction;
            this.listClear();
        },
        updateSearch(search) {
            this.search = search;
            this.listClear();
        },
        //
        // actions
        //
        // force list reload
        reload(done = null) {
            this.rnd = Math.random();
            this.done = done;
        },
        loadNextPage(args) {
            //this.page++;
            this.isAutoloadInitialized = true;
            this.page = args.index;
            this.reload(args.done);
        },
        // TODO: execute below on each reload request
        onReload() {
            /** */
        },
        refresh(done) {
            this.listClear();
            this.doneRefresh = done;
            this.reload(done);
        },
        refreshSilently() {
            if (this.listMode === 'autoload') {
                // for autoload we need to
                this.listClear();
            }
            else {
                this.rnd = Math.random(); // will force list to re-load current page
            }
        },
        filtersReset() {
            this.filters = this.$lodash.clone(this.filtersDefault);
            if (this.listMode !== 'autoload') {
                this.listClear();
                this.reload();
            }
        },
        listClear() {
            if (this.listMode === 'autoload') { // clean already loaded rows
                this.isAutoloadInitialized = false;
                this.page = 1; // set first page
                this.items = [];
                this[this.dataset] = [];
                this.lastPageItemsIndex = null;
                this.$refs.listTable.autoloadReset();
            }
            else {
                this.page = 1; // set first page
            }
        },
        listToggleEditable(args) {
            args = Object.assign({
                select: false,
                sort: false,
                edit: false,
                delete: false,
                customActions: false
            }, args);
            this.listIsEditable = !this.listIsEditable;
            if (args.select) {
                this.listToggleSelection();
            }
            // on allow editable
            // clear selection
            if (this.listIsEditable) {
                this.listUnselectAll();
            }
        },
        listToggleSelection() {
            this.listIsSelectionEnabled = !this.listIsSelectionEnabled;
            // unselect
            this.listUnselectAll();
            // modify header cells number (to match)
            if (this.header.length) {
                if (this.listIsSelectionEnabled) {
                    this.header.unshift({ checkboxSelectAll: true, tooltip: 'Select all items' });
                }
                else {
                    this.header.shift();
                }
            }
        },
        listSelectAll() {
            this.listSelected = [];
            this.items.forEach((item) => {
                item.listItemSelected = true;
                // Object.assign({}, item, {listItemSelected:false})
                this.listSelected.push(item);
            });
            //this.listSelected = this.items
        },
        listUnselectAll() {
            this.items.forEach((item) => {
                item.listItemSelected = false;
                // Object.assign({}, item, {listItemSelected:false})
            });
            this.listSelected = [];
            this.listSelectedNotifyClose();
        } /*,
        onListItemSelectionChanged () {
          if (this.listSelected.length) { // at least one item selected
          } else {
          }
        },
        onListItemSelect () {
        },
        onListItemUnselect () {
        }*/,
        onListSelectAll() {
            this.listSelectAll();
        },
        onListUnselectAll() {
            this.listUnselectAll();
        },
        listSelectedNotify() {
            const msg = 'Selected: <b>' + this.listSelected.length + '</b> item' + (this.listSelected.length > 1 ? 's' : '');
            if (!this.listSelectedFlash) {
                this.listSelectedFlash = this.flash(msg, 'action', {
                    group: false,
                    timeout: 0,
                    //badgeStyle: 'color:transparent',
                    actions: [
                        ...this.listSelectedActionButtons,
                        //...[{ label: 'Dismiss', color: 'white', handler: () => { this.listToggleSelection() } }]
                    ]
                });
            }
            else {
                this.listSelectedFlash({
                    message: msg
                });
            }
        },
        listSelectedNotifyClose() {
            try {
                this.listSelectedFlash();
                this.listSelectedFlash = null;
            }
            catch (e) { }
        },
        listSelectionActionPrompt(type, msg) {
            this.prompt.view = true;
            this.prompt.type = type;
            this.prompt.msg = msg;
        },
        listSelectionActionCancel() {
            this.listSelectedNotifyClose();
            this.listSelectedNotify();
        },
        /**
         * Filter rows data returned from server
         * (before assigned to component items property)
         * @param rows
         */
        listDataFilter(rows, index) {
            rows = this.$lodash.cloneDeep(rows);
            if (this.listMode === 'paginate') {
                //
                // paginated list mode
                //
                this.items = rows;
                return rows;
            }
            else { // listMode="autoload"
                //
                // autoload list (infinite scroll) mode
                //
                if (this.page === index.pages || // this is the last page for results
                    (rows && !rows.length) // end of the list reached (no rows more or noting found)
                ) {
                    // no more rows
                    try {
                        this.done(true);
                    }
                    catch (err) { } // true => end of results
                }
                if (this.page === 1) {
                    this.items = [];
                    this[this.dataset] = [];
                    this.loadedPages = [];
                    this.lastPageItemsIndex = null;
                }
                //
                // prevent loading this same page twice - first from apollo cache and second from graphql server response
                //
                if (this.loadedPages.indexOf(this.page) !== -1) {
                    // this page has been already loaded (primary from apollo cache)
                    // -> remove added previously (cached) page items
                    this.items.splice(this.lastPageItemsIndex);
                }
                else {
                    // this page has been not yet loaded
                    this.loadedPages.push(this.page); // index IS EQUAL TO PAGE
                    //this.lastPageItemsIndex = this.items.length   // remember page start position in items array
                }
                this.lastPageItemsIndex = this.items.length; // remember page start position in items array
                // append page
                this.items.push(...rows);
                return this.items;
            }
        },
        /**
         * Executed when data returned from server OR cache
         * @param data
         */
        onListLoaded(data) {
            this.updateIndexParameters(data);
            this.updateUrlParams();
            this.listUnselectAll();
        },
        /**
         * Update index parameters
         *
         * @param data
         */
        updateIndexParameters(data) {
            if (data) {
                this.total = data.index.total;
                this.totalPages = data.index.pages;
                if (this.listUpdateTitle) {
                    this.setTitle(this.title ? this.title : this.ui_Title, '<b>' + this.total + '</b> ' + (this.search ? 'found' : this.isAnyFilterActive ? 'filtered' : 'total'));
                }
                if (this.showNotFoundNotification) {
                    if (this.total === 0 && (this.search !== '' || this.isAnyFilterActive)) {
                        this.flash('Nothing found', 'warning');
                    }
                }
            }
            if (!this.loading) { // if loading - read from cache occurs
                try {
                    this.done();
                }
                catch (err) { }
                try {
                    this.doneRefresh();
                }
                catch (err) { }
            }
        },
        updateUrlParams() {
            if (this.listUpdateUrl) {
                const urlParams = this.buildUrlParams();
                if (this.$route.path + urlParams !== this.$route.fullPath) {
                    this.$router.replace(urlParams + this.$route.hash); // .catch((err: any)=>{}) // incl. hashtag
                }
            }
        },
        buildUrlParams() {
            let query = '';
            // base list / index parameters + search expression
            for (const key in this.index) {
                query += (query !== '' ? '&' : '?') + key + '=' + this.index[key];
            }
            // filters
            for (const key in this.filters) {
                // if (this.filters[key].constructor !== Array) {
                if (this.filters[key] !== null && this.filters[key] !== undefined) { // avoid adding 'null', 'undefined' values
                    query += (query !== '' ? '&' : '?') + 'filters[' + key + ']=' + this.filters[key];
                }
                /* } else {
                  for (let i in this.filters[key]) {
                    query += (query !== '' ? '&' : '?') + 'filters[' + key + '][]=' + this.filters[key][i]
                  }
                } */
            }
            return query;
        },
        applyUrlParams() {
            const q = this.$route.query;
            // base index parameters
            if (q.search)
                this.search = q.search;
            if (q.page)
                this.page = parseInt(q.page);
            if (q.count)
                this.count = parseInt(q.count);
            if (q.order)
                this.order = q.order;
            if (q.direction)
                this.direction = q.direction;
            // filters
            const fullPath = this.$route.fullPath.split('#')[0].split('?')[1], // remove hashtag, get only query string part
            filters = qs.parse(fullPath, { ignoreQueryPrefix: true }).filters;
            if (filters) {
                // handle special cases; bool values
                for (const index of Object.keys(filters)) {
                    switch (filters[index]) {
                        case 'true':
                            filters[index] = true;
                            break;
                        case 'false':
                            filters[index] = false;
                            break;
                    }
                }
                this.filters = filters;
            }
        }
    }
});
